module.exports = __webpack_public_path__ + "img/bespoke123_01.a67dab99.jpg";